import { Component, OnDestroy } from '@angular/core';
import { GlobalFunctionsService } from 'app/core/services/global-functions.service';
import { Course } from 'app/shared/models';
import { Subscription } from 'rxjs';

@Component({
  moduleId: module.id,
  selector: 'fo-basket',
  templateUrl: './basket.component.html'
})
export class BasketComponent implements OnDestroy {
  subscription: Subscription;
  subscriptionStudentCount: Subscription;
  selectedCourse: Course;
  showLessons = 10;
  studentCount = 0;

  constructor(private globalFunctionsService: GlobalFunctionsService) {
    this.selectedCourse = this.globalFunctionsService.getSelectedCourse();
    this.subscription = this.globalFunctionsService
      .selectedCourseUpdated()
      .subscribe(course => (this.selectedCourse = course));
    this.subscriptionStudentCount = this.globalFunctionsService
      .studentCountUpdated()
      .subscribe(count => (this.studentCount = count));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscriptionStudentCount.unsubscribe();
  }
}
